// import { createQuoteResponse } from "../data/mock/create-quote-response-mock-data.js";

//* Get the response back from the API create quote
//* and map it back to the the UI for one or two applicants.

const generalQuoteInformation = (inputData) => {
  const generalQuote = {
    jwtToken: inputData?.jwtToken,
    quoteNumber: inputData?.quoteNumber,
    firstQuote: inputData?.firstQuote == null ? false : true,
    discountPercentage: inputData?.discountPercentage,
    policyPremiumsTotal: {
      monthly: inputData?.policyPremiumsTotal.monthly,
      annual: inputData?.policyPremiumsTotal.annual,
    },
    optOutDirectMarketingQuestion: inputData?.optOutDirectMarketingQuestion,
    promoCodeValid:
      inputData?.general?.discounts?.promotionalCode?.length > 0 ? true : false,
  };
  return generalQuote;
};

const quoteInformation = (applicant) => {
  const { covers } = { ...applicant };
  const { upsell } = { ...covers };
  const hasLifeCover =
    applicant?.covers?.life?.premiums?.monthly == null ? false : true;

  const hasCriticalIllnessCover =
    applicant?.covers?.criticalIllness?.premiums?.monthly == null
      ? false
      : true;
  const hasCriticalIllnessCoverUpsell =
    applicant?.covers?.upsell?.amount == null ? false : true;

  const hasUnableToWorkCover =
    applicant?.covers?.unableToWork?.premiums?.monthly == null ? false : true;

  const response = {
    uid: applicant?.uid,
    participantPremiumsTotal: {
      monthly: applicant?.insuredPremiums.monthly,
      annual: applicant?.insuredPremiums.annual,
    },
    covers: {
      hasLifeCover: hasLifeCover,
      life: {
        sumInsured: applicant?.covers?.life.sumInsured || "",
        monthly: applicant?.covers?.life?.premiums?.monthly || "",
        annual: applicant?.covers?.life?.premiums?.annual || "",
        loading: applicant?.covers?.life?.loading || 0,
        totalLoading: applicant?.covers?.life?.totalLoading || 0,
        exclusionCodes: applicant?.covers?.life?.exclusionCodes || [],
        additionalExclusionCodes:
          applicant?.covers?.life?.additionalExclusionCodes || [],
        declineReasonList: applicant?.covers?.life?.declineReasonList || [],
      },
      hasCriticalIllnessCover: hasCriticalIllnessCover,
      hasCriticalIllnessUpSell: hasCriticalIllnessCoverUpsell,
      ...(hasCriticalIllnessCover === true ||
      hasCriticalIllnessCoverUpsell === true
        ? {
            criticalIllness: {
              sumInsured: hasCriticalIllnessCoverUpsell
                ? upsell?.amount
                : applicant?.covers?.criticalIllness?.sumInsured,
              monthly: hasCriticalIllnessCoverUpsell
                ? upsell?.monthlyPremium
                : applicant?.covers?.criticalIllness?.premiums?.monthly,
              annual: hasCriticalIllnessCoverUpsell
                ? upsell?.annualPremium
                : applicant?.covers?.criticalIllness?.premiums?.annual,
              loading: applicant?.covers?.criticalIllness?.loading || 0,
              totalLoading:
                applicant?.covers?.criticalIllness?.totalLoading || 0,
              exclusionCodes:
                applicant?.covers?.criticalIllness?.exclusionCodes || [],
              additionalExclusionCodes:
                applicant?.covers?.criticalIllness?.additionalExclusionCodes ||
                [],
              declineReasonList:
                applicant?.covers?.criticalIllness?.declineReasonList || [],
            },
          }
        : {}),
      ...(hasCriticalIllnessCoverUpsell === true && {
        upSellSums: {
          premium: upsell?.amount || "",
          monthly: upsell?.monthlyPremium || "",
          annual: upsell?.annualPremium || "",
        },
      }),
      hasUnableToWorkCover: hasUnableToWorkCover,
      ...(hasUnableToWorkCover === true && {
        unableToWork: {
          sumInsured: applicant?.covers?.unableToWork.sumInsured || "",
          monthly: applicant?.covers?.unableToWork?.premiums?.monthly || "",
          annual: applicant?.covers?.unableToWork?.premiums?.annual || "",
          loading: applicant?.covers?.unableToWork?.loading || 0,
          totalLoading: applicant?.covers?.unableToWork?.totalLoading || 0,
          exclusionCodes: applicant?.covers?.unableToWork?.exclusionCodes || [],
          additionalExclusionCodes:
            applicant?.covers?.unableToWork?.additionalExclusionCodes || [],
          declineReasonList:
            applicant?.covers?.unableToWork?.declineReasonList || [],
        },
      }),
    },
  };
  return response;
};

export const createQuoteResponseMapping = (inputData) => {
  //* the input data is the response from the API call to
  //* create quote.;
  if (!inputData) return;

  const response = {};
  const { data } = { ...inputData };
  if (data == null) return;

  const { insuredParticipants } = { ...data };
  const personOne = insuredParticipants[0];

  //? General Quote information
  response.quoteInformation = generalQuoteInformation(data);
  //? Applicant (person) One
  response.personOneQuoteInfo = quoteInformation(personOne);
  response.numberOfApplicants = 1;

  //? Applicant (person) Two - If applicable
  if (insuredParticipants?.[1]) {
    const personTwo = insuredParticipants[1];
    response.personTwoQuoteInfo = quoteInformation(personTwo);
    response.numberOfApplicants = 2;
  }
  return response;
};
